import Preview from "../../features/preview/Preview";
import "./ConfigPageLayout.css";
import { ReactElement } from "react";

function ConfigPageLayout(props: {children : ReactElement}){

    return (
        <div className='config-page-container'>
            <div className="config-page-component-conatainer">
                {props.children}
            </div>
            <div className="config-page-preview-container">
                <Preview />
            </div>
        </div>
    );
}

export default ConfigPageLayout;